import ModalHeader from "./modal-header";

export default ModalHeader;